import { render, staticRenderFns } from "./EmailRecipients.vue?vue&type=template&id=31e0dadb&scoped=true&lang=pug"
import script from "./EmailRecipients.vue?vue&type=script&lang=js"
export * from "./EmailRecipients.vue?vue&type=script&lang=js"
import style0 from "./EmailRecipients.vue?vue&type=style&index=0&id=31e0dadb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0dadb",
  null
  
)

export default component.exports